<template>
    <dashboard-filter
      :is-disabled="isDisabled"
      @change="emitHandler">
      <option
        selected
        value=""
      >
        {{ $t('ui.dashboard.filter.all_projects') }}
      </option>
      <option
        v-for="project in projects"
        :value="project.id"
      >
          {{ project.name }}
        </option>
    </dashboard-filter>
</template>

<script>
import map from 'lodash/fp/map'
import sortBy from 'lodash/fp/sortBy'
import flow from 'lodash/flow'

import DashboardFilter from './DashboardFilter'
import ProjectApi from '@/api/Project.js'
import FilterMixin from './mixins/FilterMixin'

export default {
  mixins: [FilterMixin],

  components: {
    DashboardFilter
  },

  props: ['organizationId'],

  data: () => ({
    projects: []
  }),

  async mounted () {
    await this.refresh()
  },

  watch: {
   async organizationId() {
      await this.refresh()
   }
  },

  methods: {
    async refresh() {
        const projects = await this.get()
        this.projects = this.transform(projects)
    },

    get() {
      return new Promise(async (resolve, reject) => {
        try {
          let projectApi = new ProjectApi()

          const projects = await projectApi.getShortList({filter_by: 'organization_id', filter_value: this.organizationId})

          resolve(projects)
        } catch (error) {
          reject(error)
        }
      })
    },

    transform: projects => flow([
      sortBy(['name']),
      map(({ name, id }) => ({ name, id }))
    ])(projects)
  }
}
</script>



// WEBPACK FOOTER //
// ProjectFilter.vue?57132a74